import $ from 'jquery';

let customSelect;
let i;
let selectedElement;
let div;
let optionDiv;
let optionItem;

/* look for any elements with the class "c-custom-select": */
customSelect = document.getElementsByClassName('c-custom-select');

for (i = 0; i < customSelect.length; i++) {
  selectedElement = customSelect[i].getElementsByTagName('select')[0];
  /* for each element, create a new DIV that will act as the selected item: */
  div = document.createElement('DIV');
  div.setAttribute('id', `${selectedElement.getAttribute('id')}-${i}`);
  div.setAttribute('class', 'c-custom-select__selected');
  div.setAttribute('role', 'listbox');
  div.setAttribute('aria-expanded', 'false');
  div.setAttribute('aria-label', selectedElement.getAttribute('title'));
  div.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
  div.tabIndex = 0;
  customSelect[i].appendChild(div);
  /* for each element, create a new DIV that will contain the option list: */
  optionDiv = document.createElement('DIV');
  optionDiv.setAttribute('class', 'c-custom-select__items c-custom-select__items--hide');
  optionDiv.setAttribute('aria-labelledby', `${selectedElement.getAttribute('id')}-${i}`);

  for (let j = 0; j < selectedElement.length; j++) {
    /* for each option in the original select element,
    create a new DIV that will act as an option item: */
    optionItem = document.createElement('DIV');
    optionItem.setAttribute('class', 'c-custom-select__option');
    optionItem.setAttribute('role', 'option');
    optionItem.tabIndex = 0;
    optionItem.innerHTML = selectedElement.options[j].innerHTML;

    if (selectedElement.options[j].disabled) {
      optionItem.style.pointerEvents = 'none';
      optionItem.classList.add('disabled');
    }

    if (selectedElement.options[j].selected) {
      optionItem.classList.add('c-custom-select__items--selected');
      optionItem.setAttribute('aria-selected', 'true');
    }

    optionItem.addEventListener('click', selectOption);
    optionItem.addEventListener('keydown', (e) => {
      const keyCode = (e.keyCode ? e.keyCode : e.which);

      if (keyCode === 13) {
        e.target.click();
      }

      if (keyCode === 38) { // up
        e.preventDefault();

        const currentElement = $(document.activeElement).index();

        if (currentElement > 0) {
          $(document.activeElement).parent().children().eq(currentElement - 1)
            .focus();
        }
      }

      if (keyCode === 40) { // down
        e.preventDefault();

        const currentElement = $(document.activeElement).index();
        const { length } = $(document.activeElement).parent().children();

        if (currentElement < length - 1) {
          $(document.activeElement).parent().children().eq(currentElement + 1)
            .focus();
        }
      }
    });
    optionDiv.appendChild(optionItem);
  }

  customSelect[i].appendChild(optionDiv);
  div.addEventListener('click', toggleCustomSelect);
  div.addEventListener('keydown', (e) => {
    const keyCode = (e.keyCode ? e.keyCode : e.which);

    if (keyCode === 13) {
      e.target.click();
    }
  });
}

function toggleCustomSelect(e) {
  e.stopPropagation();
  closeAllSelect(this);
  this.nextSibling.classList.toggle('c-custom-select__items--hide');
  this.setAttribute('aria-expanded', this.nextSibling.classList.contains('c-custom-select__items--hide') ? 'false' : 'true');
  this.classList.remove('open');

  if (!this.nextSibling.classList.contains('c-custom-select__items--hide')) {
    this.classList.add('open');
  }
}

function selectOption(e) {
  /* when an item is clicked, update the original select box,
  and the selected item: */
  let y;
  let i;
  let k;
  let select;
  let h;
  select = this.parentNode.parentNode.getElementsByTagName('select')[0];
  h = this.parentNode.previousSibling;

  for (i = 0; i < select.length; i++) {
    if (select.options[i].innerHTML == this.innerHTML) {
      select.selectedIndex = i;
      h.innerHTML = this.innerHTML;
      y = this.parentNode.querySelectorAll('.c-custom-select__items--selected');

      for (k = 0; k < y.length; k++) {
        y[k].classList.remove('c-custom-select__items--selected');
        y[k].setAttribute('aria-selected', 'false');
      }

      this.classList.add('c-custom-select__items--selected');
      this.setAttribute('aria-selected', 'true');

      break;
    }
  }

  h.click();
  $(select).trigger('change');
}

function closeAllSelect(element) {
  /* a function that will close all select boxes in the document,
  except the current select box: */

  let x;
  let y;
  let i;
  const arrNo = [];

  x = document.getElementsByClassName('c-custom-select__items');
  y = document.getElementsByClassName('c-custom-select__selected');

  if (y[0]) {
    y[0].setAttribute('aria-expanded', 'false');
  }

  for (i = 0; i < y.length; i++) {
    if (element == y[i]) {
      arrNo.push(i);
    }
    y[i].classList.remove('open');
  }

  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('c-custom-select__items--hide');
    }
  }
}

/* if the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener('click', closeAllSelect);
document.addEventListener('scroll', closeAllSelect);
